import packageJson from '../../package.json';

// Runtime environment configuration.
//
// Values are read from `window.__env`, which is populated by `env.js`:
// - Local development (`ng serve`): the checked-in `public/env.js` is empty,
//   so the development defaults below apply. No arguments needed.
// - Docker/Dokploy: `env.js` is regenerated from container environment
//   variables at startup (see docker/mobile/Dockerfile and env-config.sh),
//   so new environments require no code changes or rebuilds.

interface RuntimeEnv {
  production?: boolean | string;
  apiUrl?: string;
  authAuthority?: string;
  authClientId?: string;
  authClientSecret?: string;
  authScope?: string;
  appVersionSuffix?: string;
  connectBaseUrl?: string;
}

const runtimeEnv: RuntimeEnv = (window as Window & { __env?: RuntimeEnv }).__env ?? {};

export const environment = {
  appVersion: packageJson.version + (runtimeEnv.appVersionSuffix ?? '-dev'),
  production: String(runtimeEnv.production ?? '') === 'true',
  apiUrl: runtimeEnv.apiUrl || 'https://dev-api.microbuildmanagement.no/',
  authSettings: {
    authority: runtimeEnv.authAuthority || 'https://identityserver.devmicrobuild.no',
    clientId: runtimeEnv.authClientId || 'mb-management-mobile',
    clientSecret: runtimeEnv.authClientSecret || 'mb-management-mobile-LLTJVY',
    scope: runtimeEnv.authScope || 'openid management offline_access profile',
  },
  connectBaseUrl: runtimeEnv.connectBaseUrl || 'https://dev.microbuildconnect.no/',
};